// extracted by mini-css-extract-plugin
module.exports = {"_linkstyle":"LinkStyle__linkstyle_25y6J fw6 underline green _collision"};